import type { SVGProps } from 'react';
import { useId } from 'react';

export interface ContractedIconProps extends Omit<SVGProps<SVGSVGElement>, 'xmlns' | 'children'> {}

const ContractedIcon = ({
  className,
  width = '20',
  height = '20',
  ...rest
}: ContractedIconProps) => {
  const clipPathId = useId().replace(/:/g, '');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      {...rest}
      width={width}
      height={height}
      className={className}
      fill="none"
      aria-hidden={true}
      focusable="false"
    >
      <defs>
        <clipPath id={clipPathId}>
          <rect width="9" height="12" fill="white" transform="translate(5.5 4)" />
        </clipPath>
      </defs>
      <rect width="20" height="20" rx="10" fill={'#008EDC'} />
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M12.2905 4.01794C12.3698 3.99101 12.3996 3.98341 12.3699 4.08403C12.3661 4.20828 12.3043 4.34425 12.2815 4.46338C12.1506 5.14558 12.0578 5.8737 12.0515 6.56995C12.0488 6.87577 12.0799 7.18192 12.084 7.48775C12.0945 7.54756 12.0966 7.60819 12.0905 7.66999L12.0999 7.65297C12.1217 7.90807 12.1654 8.20547 12.2111 8.46255L12.227 8.54516C12.514 10.0731 13.1851 11.5244 14.0921 12.7353L14.4985 13.2044H13.9346C13.8982 13.2044 13.4136 12.815 13.3472 12.758C11.8246 11.4474 10.8922 9.5089 10.6624 7.47139C10.6072 7.5203 10.5443 7.57763 10.4964 7.63298C9.68245 8.57292 8.96637 9.62852 8.45013 10.771C8.26507 11.1804 8.08367 11.6059 7.98582 12.0478C8.2522 11.93 8.52494 11.823 8.80832 11.7552C9.75218 11.5295 10.7731 11.6279 11.6745 11.9201L11.9407 12.0312C11.8065 12.0366 11.6726 12.0619 11.5408 12.086C9.09774 12.5338 7.03291 13.9831 5.53945 15.9801C5.49879 16.0269 5.4883 15.9938 5.50768 15.881C5.51324 15.404 5.72101 14.5638 5.82998 14.0766C6.53318 10.9333 8.20042 6.99456 10.6668 4.94384C11.0059 4.66197 11.8715 4.05297 12.2907 4.01794H12.2905Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default ContractedIcon;
